import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { Button, ControlLabel, FormGroup, FormControl, Panel } from 'react-bootstrap';
import { FormattedMessage } from 'react-intl';
import Spinner from 'components/Spinner';
import messages from './messages';
import { makeRequest } from '../../services/LoginType';
import { getLoadingStatus } from './selectors';

import styles from './styles.css';

const LoginTypeForm = ({ onSubmit, loading, onUsernameUpdate }) => {

  const [username, setUsername] = useState('');

  function handleChange(event) {
    const { value } = event.target;
    setUsername({ userName: value });
    onUsernameUpdate(value);
  }

  function handleSubmit(event) {
    event.preventDefault();
    event.stopPropagation();
    onSubmit(username);
  }
  return (
    <Panel className={styles.loginPanel} >
      <h1>{messages.title.defaultMessage}</h1>
      <Panel.Body className={styles.Padding}>
        {loading ?
          <div className={styles.loginSpinnerContainer}> <Spinner text="" className="signin-spinner" /></div> :
          <form action="" onSubmit={handleSubmit}>
            <FormGroup controlId="userName">
              <ControlLabel><FormattedMessage {...messages.loginTypeUsername} /></ControlLabel>
              <FormControl type="text" required autoComplete="username" onChange={handleChange} />
              <p>For added security, please enter your username or e-mail address first. We will request your password on the following screen.</p>
            </FormGroup>
            <Button
              type="submit"
              bsStyle="primary"
              className={`form-control ${styles.loginButton}`}
            >
              <FormattedMessage {...messages.checkUsername} />
            </Button>
          </form>
        }
      </Panel.Body>
    </Panel>
  );

};

LoginTypeForm.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired,
  onUsernameUpdate: PropTypes.func.isRequired,
};

const mapStateToProps = createStructuredSelector({
  loading: getLoadingStatus,
});

/* istanbul ignore next */
const mapDispatchToProps = (dispatch) => ({
  onSubmit: (params) => {
    dispatch(makeRequest(params));
  },
});

export { NAMESPACE, LEGIT_SERVICE_CONFIG } from './constants';
export { default as reducer } from './reducer';
export default connect(mapStateToProps, mapDispatchToProps)(LoginTypeForm);



// WEBPACK FOOTER //
// ./src/containers/Login/LoginTypeForm.js